import { membershipTiersOptions } from '@api';

import { useAuth } from '@shared/common/providers/AuthProvider';
import { useRefetchAllocationsByPool } from '@shared/hooks/useRefetchAllocationsByPool';

import { useLaunchpadSaleQuery } from '@query/launchpadProjects';

import useSelfDepositedAmountQuery from '@launchpad/hooks/useSelfDepositedAmountQuery';

export const useAvailableAllocation = (poolId: string, isSqrpBasedOffchainPool?: boolean) => {
  const { data: pool, isPending: isPoolLoading } = useLaunchpadSaleQuery(poolId);
  const { user, isAuth } = useAuth();

  const { getSelfAllocationByPool } = useRefetchAllocationsByPool(pool);

  const selfTierId = user?.membershipTier.attributes.key;

  const tierIndex = membershipTiersOptions.findIndex((option) => option.value === selfTierId);

  const maxAllocation =
    (isAuth
      ? isSqrpBasedOffchainPool
        ? pool?.included?.find((item) => item.type === 'membershipDependentAttributes')?.attributes
            ?.settings?.values[tierIndex] ?? pool?.attributes.maxAllocation
        : pool?.attributes.maxAllocation
      : pool?.attributes.maxAllocation) || 0;

  const { data: selfDepositInfo, isPending: isLoadingSelfDeposite } = useSelfDepositedAmountQuery({
    depositContractAddress: pool?.attributes.depositContractAddress,
    type: pool?.attributes.type,
  });

  const selfDepositedAmount =
    (isSqrpBasedOffchainPool
      ? getSelfAllocationByPool(pool?.attributes.type)
      : selfDepositInfo?.baseDeposited) || 0;

  const availableAllocation = Math.max(maxAllocation - selfDepositedAmount, 0);

  return { availableAllocation, maxAllocation, isLoading: isLoadingSelfDeposite || isPoolLoading };
};
